import list from "./list";
import edit from "./edit";
import users from "./users";
import show from "./show";

export default {
  namespaced: true,
  modules: { list, show , edit, users }
};
